import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage, defineMessages } from 'react-intl';

import { transferMarket } from '@sorare/core/src/lib/glossary';

import type { TransactionsPrimaryOfferTitle_tokenPrimaryOffer } from './__generated__/index.graphql';

const messages = defineMessages({
  title: {
    id: 'FiatTransactionsHistoryPrimaryOffer.title.v2',
    defaultMessage: 'Cart',
  },
});

type Props = {
  tokenPrimaryOffer: TransactionsPrimaryOfferTitle_tokenPrimaryOffer;
};

export const TransactionsPrimaryOfferTitle = ({ tokenPrimaryOffer }: Props) => {
  if (tokenPrimaryOffer.cards.length > 1)
    return <FormattedMessage {...messages.title} />;
  return <FormattedMessage {...transferMarket.instantBuy} />;
};

TransactionsPrimaryOfferTitle.fragments = {
  tokenPrimaryOffer: gql`
    fragment TransactionsPrimaryOfferTitle_tokenPrimaryOffer on TokenPrimaryOffer {
      id
      cards: anyCards {
        slug
      }
    }
  ` as TypedDocumentNode<TransactionsPrimaryOfferTitle_tokenPrimaryOffer>,
};
